<template>
  <div id="app" >
    <el-container class="fullContainer">
      <div class="mincontainer">
        <el-container>
          <el-header>
            <Header />
          </el-header>
          <el-main>
            <router-view />
          </el-main>
          <el-footer>
            <Footer />
          </el-footer>
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"

export default {
  name: "MainLayout",
  mounted() {},
  components: {
    Header,
    Footer,
  },
  computed: {
  },
}
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: "Segoe UI", "Microsoft JhengHei", "Microsoft YaHei", "Arial";
  font-size: 14px;
}
body {
  background-color: #efefef;
}
body .el-input.is-disabled .el-input__inner {
  color: #606266;
}
.boxContain {
  margin: 10px 0;
}
.el-header {
  padding: 0;
  z-index: 100;
}
.el-main {
  box-sizing: border-box;
  padding: 20px 0px 100px 0px;
  width: 80%;
  margin: 0 auto;
}
.el-footer {
  height: 50px !important;
  padding: 0;
}
body .el-select {
  width: 100%;
}
body .el-date-editor {
  width: 100%;
}
.mincontainer {
  box-sizing: border-box;
  width: 100%;
}
.mincontainer > .el-container > .el-main {
  padding-bottom: 20px;
}
.menuOpen .mincontainer {
  padding-left: 300px;
}

.fullContainer.sidemenu-close .sidemenu-left {
  transition: all 0.3s ease-out;
  transform: translateX(-300px);
}

.fullContainer.sidemenu-close .mincontainer {
  padding-left: 0px;
}
.fullContainer.sidemenu-close .fixed-top {
  left: 0px;
}
h3 {
  color: #009ae0;
  margin: 0.5rem 0;
}
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
body .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
@media (max-width: 1025px) {
  .sidemenu-left {
    display: none;
  }
  .el-main {
    padding: 20px;
  }
  .menuOpen .mincontainer {
    padding-left: 0px;
    /*background: #000000;*/
  }
  .menu-side:not(.el-menu--collapse) {
    width: 240px;
    /*border-right: solid 0px #e6e6e6;*/
  }
  .menuSideTopBox {
    display: none;
  }
  #app .nav-item {
    border-top: 1px #ccc solid;
    border-bottom: 1px #ccc solid;
    margin: 50px 0 10px 0;
    padding: 10px 0 10px 10px;
  }
  #app .nav-item span {
    color: #000000;
  }
  #app .menu-side {
    top: 150px;
    background-color: none;
  }
  .menu-side-title {
    display: none;
  }
  #app .sidenav {
    background-color: #fff;
  }
  #app .menuitem {
    background-color: red;
  }
  .sidenav li > div > span {
    background-color: #0089c8;
  }
  .el-row .el-col-12 {
    width: 100%;
  }
  h3.includeBtn {
    margin-top: 30px;
  }
  .boxContain.includeBtn .c-table-top-right-btn {
    position: absolute;
    top: -50px;
    right: 0px;
  }
}
</style>
